module.exports = __webpack_public_path__ + "img/multimarker.62b666f5.png";